export const SET_SKIN = "SET_SKIN";
export const UPDATE_SKIN = "UPDATE_SKIN";

export const ADD_CONTACT = "ADD_CONTACT";
export const UPDATE_CONTACT = "UPDATE_CONTACT";

export const ADD_EDUCATION ="ADD_EDUCATION";
export const UPDATE_EDUCATION = "UPDATE_EDUCATION";